import React from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useThemeContext } from '../contexts/ThemeContext';

interface CRTEffectProps {
  children: React.ReactNode;
}

export default function CRTEffect({ children }: CRTEffectProps) {
  const { themeMode } = useThemeContext();
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  
  if (themeMode !== 'retro') {
    return <>{children}</>;
  }

  if (prefersReducedMotion) {
    return (
      <Box
        sx={{
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(18, 16, 16, 0.1)',
            pointerEvents: 'none',
            zIndex: 1000,
          },
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `
            linear-gradient(
              rgba(18, 16, 16, 0) 50%, 
              rgba(0, 0, 0, 0.25) 50%
            ),
            linear-gradient(
              90deg, 
              rgba(255, 0, 0, 0.06), 
              rgba(0, 255, 0, 0.02), 
              rgba(0, 0, 255, 0.06)
            )
          `,
          backgroundSize: '100% 2px, 3px 100%',
          pointerEvents: 'none',
          zIndex: 1000,
        },
        '&::after': {
          content: '""',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(18, 16, 16, 0.1)',
          opacity: 0.9,
          pointerEvents: 'none',
          animation: 'flicker 0.15s infinite linear alternate',
          zIndex: 1001,
        },
        '@keyframes flicker': {
          '0%': { opacity: 1 },
          '100%': { opacity: 0.95 },
        },
      }}
    >
      {children}
    </Box>
  );
}